module.exports = __webpack_public_path__ + "img/fernando-huerta.7bccab30.png";